<template>
  <div class="container">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
.container {
  padding: 1rem 4.5rem;
  width: 80%;
}
</style>
